import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { useIcons } from "../../../../hooks/useIcons";
import { useExternalMedia } from "../../../../hooks/useExternalMedia";


const Contain = styled.div`
  cursor: pointer;
`;

const LogoContainer = styled(Contain)`
  width: 100px;
  height: 40px;
  align-self: flex-start;
`;

const MenuContainer = styled(Contain)`
  width: 32px;
  height: 32px;
  align-self: flex-end;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
`;



export default function Navbar() {

  const { navIcon } = useIcons();

  const { logo } = useExternalMedia();
  return (
    <>
      <section
        className="my-3"
      >
        <Container>
          <Row>
            <Col>
              <LogoContainer>
                <a
                  href='/'
                  title="Home"
                  hrefLang="en-us"
                >
                  <Img
                    alt="Era-tek logo"
                    src={logo}
                  />
                </a>
              </LogoContainer>
            </Col>

            {/* <Col
          className="display-contents"
        >
          <MenuContainer>
            <Img
              alt="Menu"
              src={navIcon}
            />
          </MenuContainer>
        </Col> */}
          </Row>
        </Container>
      </section>
    </>
  )
}
